import React from "react";

import * as SC from "./PrintChannels.styled";
import useChannelsIcon from "../../../PagesUser/Campaign/DataVisualization/hooks/useChannelsIcon";

const PrintChannels = ({ channels }) => {
  const { renderIcons } = useChannelsIcon();

  return channels.map((channel, index) => (
    <SC.OptionsChannels key={channel}>
      <SC.ChannelIcon>
        <SC.BoxIcon index={index}>
          <SC.ChannelIconWrapper>{renderIcons(channel)}</SC.ChannelIconWrapper>
        </SC.BoxIcon>
      </SC.ChannelIcon>
    </SC.OptionsChannels>
  ));
};

export default PrintChannels;
